import script from "./ExportTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./ExportTableRow.vue?vue&type=style&index=0&id=23803672&lang=scss"

const __exports__ = script;

export default __exports__